import React from "react";

function Footer() {
  return (
    <footer style={{ backgroundColor: "rgb(240,240,240)" }}>
      <div className="container mt-5 border-top pt-4">

        {/* Top Section */}
        <div className="row">

          {/* Brand */}
          <div className="col-12 col-md-4 mb-4">
            <h5 className="fw-bold">Stock Platform</h5>
            <p className="text-muted">
              © 2026 Stock Platform Ltd. All rights reserved.
            </p>
          </div>

          {/* Company */}
          <div className="col-6 col-md-2 mb-4 text-muted">
            <p className="fw-semibold">Company</p>
            <a href="#" className="d-block text-decoration-none">About</a>
            <a href="#" className="d-block text-decoration-none">Products</a>
            <a href="#" className="d-block text-decoration-none">Pricing</a>
            <a href="#" className="d-block text-decoration-none">Referral programme</a>
            <a href="#" className="d-block text-decoration-none">Careers</a>
            <a href="#" className="d-block text-decoration-none">Zerodha.tech</a>
            <a href="#" className="d-block text-decoration-none">Press & media</a>
            <a href="#" className="d-block text-decoration-none">Zerodha cares (CSR)</a>
          </div>

          {/* Support */}
          <div className="col-6 col-md-3 mb-4 text-muted">
            <p className="fw-semibold">Support</p>
            <a href="#" className="d-block text-decoration-none">Contact</a>
            <a href="#" className="d-block text-decoration-none">Support portal</a>
            <a href="#" className="d-block text-decoration-none">Z-connect blog</a>
            <a href="#" className="d-block text-decoration-none">List of charges</a>
            <a href="#" className="d-block text-decoration-none">Downloads & resources</a>
          </div>

          {/* Account */}
          <div className="col-6 col-md-3 mb-4 text-muted">
            <p className="fw-semibold">Account</p>
            <a href="#" className="d-block text-decoration-none">Open an account</a>
            <a href="#" className="d-block text-decoration-none">Fund transfer</a>
            <a href="#" className="d-block text-decoration-none">60 day challenge</a>
          </div>

        </div>

        {/* Bottom Legal Text */}
        <div className="mt-4 text-muted" style={{ fontSize: "14px", lineHeight: "1.6" }}>
          
          <p>
            Stock Trading Platform Broking Ltd.: Member of NSE & BSE – SEBI Registration no:
            INZ000031633. Depository services through Zerodha Securities Pvt. Ltd.
          </p>

          <p>
            Procedure to file a complaint on SEBI SCORES: Register on SCORES portal with
            details like Name, PAN, Address, Mobile Number, and Email ID.
          </p>

          <p>
            Investments in securities market are subject to market risks; read all related
            documents carefully before investing.
          </p>

          <p>
            Prevent unauthorised transactions in your account. Update your mobile/email with
            your broker to receive alerts directly from the exchange.
          </p>

        </div>

      </div>
    </footer>
  );
}

export default Footer;